import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UPDATE_DAYCARE_MEAL_TEXTURE } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'
import { MealTexture } from '@/types/Meal.ts'

interface UpdateMealTextureDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
    texture: MealTexture
}

const UpdateMealTextureDialog: FunctionComponent<UpdateMealTextureDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId,
    texture
}: UpdateMealTextureDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [value, setValue] = useState<string>(texture.texture)

    useEffect(() => {
        setValue(texture.texture)
    }, [texture])

    const [updateMealTexture] = useMutation(UPDATE_DAYCARE_MEAL_TEXTURE, {
        variables: { daycareId, textureId: texture.id, texture: value },
        onCompleted: () => {
            refetch()
            handleClose()
            showNotificationSuccess(t('mealTextureUpdated'))
        },
        onError: () => {
            handleClose()
            showNotificationError(t('mealTextureUpdatedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('updateMealTexture')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={value}
                    setValue={setValue}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 2, max: 255 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='confirm'
                        disabled={value.length < 2 || value.length > 255 || value === texture.texture}
                        onClick={() => updateMealTexture()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default UpdateMealTextureDialog
